import React from "react";
import ReactDOM from "react-dom";
import { withSuspense } from "zeta-dom-react";
import { Loading } from "src/components/common";
import "src/util/screenFix";

const App = withSuspense(() => import("./App"), Loading);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

if (process.env.NODE_ENV === 'development') {
    // @ts-ignore
    import("@misonou/cra-disable-runtime-error");
}
